<template>
  <div>
    <!-- :pagination="{
        showSizeChanger: true,
        total: Number(detail.totalNum),
        current: Number(detail.currentPage),
        pageSize: Number(detail.pageSize)
      }"
      @change="change" -->
    <a-table
      class="table-component"
      :loading="loading"
      :bordered="true"
      :dataSource="detail.result"
      :columns="columns"
    >
      <template #bodyCell="{ column, record, text, index }">
        <template v-if="column.key === 'index'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'userAccount'">
          <span class="account-name">{{ text }}</span>
        </template>
        <template v-if="column.key === 'action'">
          <a @click="() => edit(record)">编辑</a>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import { ref } from "vue";
import { Table } from "ant-design-vue";
import { INFO_TABLE_COLUMNS } from "@/constant/views/dashboard/operation-index/user-index";

export default {
  name: "info-table",
  components: {
    [Table.name]: Table
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    loading: Boolean
  },
  setup(props, context) {
    const userEdit = ref(null);
    const change = (pagination) => {
      context.emit("onGetList", {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      });
    };
    const edit = (record) => {
      userEdit.value.showModal(record);
    };

    const update = () => {
      context.emit("onGetList");
    };
    return {
      userEdit,
      columns: INFO_TABLE_COLUMNS,
      change,
      edit,
      update
    };
  }
};
</script>
